import React, { useEffect, useState } from "react";
import classes from './Transactions.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from 'react-router-dom';
// use centralized API wrapper
import api from '../../Components/API/Api';
import { Pencil, Trash2, Printer } from 'lucide-react';
// BASE_URL is provided by API module when needed
import { useUser } from '../../UserContext';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Swal from 'sweetalert2';

const Transactions = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [metrics, setMetrics] = useState({
        total_sales: 0,
        outstanding: 0,
        total_invoices: 0,
        // overdue: 0, 
    });

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };


    const { user } = useUser();

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const companyIdHeader = (user && (user.company_id || user?.company?.id)) || localStorage.getItem('company_id') || null;

                // Fetch invoices using centralized api wrapper
                const response = await api.get(`/v1/fetch-sales-invoice`);
                setInvoiceItems(response.data?.data || []);

                // Fetch metrics using centralized api wrapper
                const metricsRes = await api.get(`/v1/metrics/sales-invoice-metrics`);
                if (metricsRes.data?.data) {
                    setMetrics(metricsRes.data.data);
                }
            } catch (error) {
                console.error("Failed to fetch invoices/metrics:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoices();
    }, [user]);

    const handleReverseInvoice = async (item) => {
        // Confirm deletion
        const result = await Swal.fire({
            title: 'Reverse Sales Invoice',
            text: 'Are you sure you want to reverse this sales invoice? This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reverse it!'
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            const response = await api.post(`/v1/reverse_sales_invoice`, { 
                invoice_id: item.id,
                invoice_number: item.invoice_number
            });
            
            if (response.status === 200 || response.status === 201) {
                // Remove the item from the table
                setInvoiceItems(invoiceItems.filter(invoiceItem => invoiceItem.id !== item.id));
                Swal.fire({
                    title: 'Success!',
                    text: 'Sales invoice reversed successfully.',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                });
            }
        } catch (error) {
            console.error("Failed to reverse invoice:", error);
            Swal.fire({
                title: 'Error!',
                text: error.response?.data?.message?.invoice_number?.[0] || 'Error reversing sales invoice. Please try again.',
                icon: 'error',
                confirmButtonColor: '#3085d6'
            });
        }
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>

                <div className={classes.Container}>
                    <div className={classes.actions}>
                        <button className={classes.btns}>New Sales Invoice</button>
                        <button className={classes.btns}>New Purchase Invoice</button>
                        <button className={classes.btns}>All Invoices</button>
                        <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                    </div>

                    <header className={classes.Header}>
                        <h2 className={classes.Title}>Sales Invoice</h2>
                        <h1 className={classes.Titles}>
                            Manage your sales transactions, invoices, and customer payments.
                        </h1>
                    </header>

                    <div className={classes.entrjj}>
                        <div className={classes.allkads}>
                            <div className={classes.thrdkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Total sales</p>
                                    <p className={classes.kdptg1}>
                                        ₦{Number(metrics.total_sales).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>This month</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frtkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Outstanding</p>
                                    <p className={classes.kdptg2}>
                                        ₦{Number(metrics.outstanding).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Pending payments</p>
                                    </div>
                                </div>
                            </div>
                            {/* <div className={classes.fiftkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Overdue</p>
                                    <p className={classes.kdptg3}>
                                        ₦{Number(metrics.overdue || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Past due dates</p>
                                    </div>
                                </div>
                            </div> */}
                            <div className={classes.frstkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>This month</p>
                                    <p className={classes.kdptg4}>{metrics.total_invoices}</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Total invoices</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className={classes.headerActions}>
                        <div className={classes.actionsRight}>
                            <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search sales" />
                            </div>
                            <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                    <option value="">All Status</option>
                                    <option value="Paid">Paid</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Overdue">Overdue</option>
                                    <option value="Draft">Draft</option>
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                            </div>
                            <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                            </div>
                        </div>
                        <button className={classes.btnss} onClick={() => navigate('/transactions/newaction')}> + New items</button>
                    </div>
                    {/* <div className={classes.action}>
                        <button className={classes.btn} onClick={() => navigate('/transactions/newaction')}>
                            + Action
                        </button>
                    </div> */}
                    <div className={classes.invoicecont}>
                        <table className={classes.invoiceTable}>
                            <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>Transaction Date</th>
                                    <th>Invoice Number</th>
                                    <th>Customer</th>
                                    <th>Description</th>
                                    <th>Total Amount</th>
                                    {/* <th>Total Paid</th> */}
                                    {/* <th>Balance</th> */}
                                    {/* <th>Status</th> */}
                                    <th>Post Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    [...Array(5)].map((_, i) => (
                                        <tr key={i}>
                                            {[...Array(8)].map((__, j) => (
                                                <td key={j}><div className={classes.skeleton}></div></td>
                                            ))}
                                        </tr>
                                    ))
                                ) : invoiceItems.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                            No sales invoices found.
                                        </td>
                                    </tr>
                                ) : (
                                    invoiceItems.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{index + 1}</td>
                                            <td>{item.transaction_date || "—"}</td>
                                            <td>{item.invoice_number || item.uuid || "—"}</td>
                                            <td style={{textAlign: 'left'}}>
                                                <span className={classes.truncateName}>
                                                    {item.customer?.name || item.customer_id || "—"}
                                                </span>
                                            </td>


                                            <td style={{textAlign: 'left'}}>
                                                {(() => {
                                                    if (Array.isArray(item.sales) && item.sales.length > 0) {
                                                        const parts = item.sales.map(s => {
                                                            if (s.item) {
                                                                return s.item.name || s.item.description || s.item_id || '';
                                                            }
                                                            return s.item_id || '';
                                                        }).filter(Boolean);

                                                        return parts.length ? parts.join(', ') : (item.description || '—');
                                                    }

                                                    return item.description || '—';
                                                })()}
                                            </td>
                                            <td style={{textAlign:'right'}}>{Number(item.amount || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                            {/* {(() => {
                                                const toNum = (v) => {
                                                    const n = parseFloat(v);
                                                    return isNaN(n) ? 0 : n;
                                                };

                                                // Sum all debits from customer's ledgers (or item.ledgers fallback)
                                                const ledgers = Array.isArray(item.customer?.ledgers)
                                                    ? item.customer.ledgers
                                                    : (Array.isArray(item.ledgers) ? item.ledgers : []);

                                                const totalPaidFromLedgers = ledgers.reduce((sum, l) => sum + toNum(l?.debit), 0);

                                                // If no ledgers, fall back to invoice-level debit if provided
                                                const totalPaid = totalPaidFromLedgers > 0 ? totalPaidFromLedgers : toNum(item.debit);

                                                const balance = Math.max(0, toNum(item.amount) - totalPaid);

                                                return (
                                                    <>
                                                        <td style={{textAlign:'right'}}>{Number(totalPaid || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                                        <td style={{textAlign:'right'}}>{Number(balance || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                                    </>
                                                );
                                            })()} */}

                                            {/* <td>
                                                {(() => {
                                                    const toNum = (v) => {
                                                        const n = parseFloat(v);
                                                        return isNaN(n) ? 0 : n;
                                                    };

                                                    // Prefer invoice-level fields if present
                                                    const debitNum = toNum(item.debit);
                                                    const creditNum = toNum(item.credit);
                                                    const amountNum = toNum(item.amount);

                                                    if (!isNaN(creditNum)) {
                                                        // Rule 1: no credit amount => Owing
                                                        if (creditNum === 0) {
                                                            return <span className={classes.statusPending}>Owing</span>;
                                                        }
                                                        // Rule 3: debit zero => Paid
                                                        if (debitNum === 0) {
                                                            return <span className={classes.statusPaid}>Paid</span>;
                                                        }
                                                        // Rule 2: debit not equal to amount => Paid Part
                                                        if (amountNum > 0 && debitNum !== amountNum) {
                                                            return <span className={(classes.statusWarning || classes.statusPending)}>Paid Part</span>;
                                                        }
                                                        // Default for other combos
                                                        return <span className={classes.statusPending}>Owing</span>;
                                                    }

                                                    // Fallback to ledgers aggregation when invoice fields absent
                                                    const ledgers = Array.isArray(item.customer?.ledgers)
                                                        ? item.customer.ledgers
                                                        : (Array.isArray(item.ledgers) ? item.ledgers : []);

                                                    if (ledgers.length > 0) {
                                                        const totals = ledgers.reduce((acc, l) => ({
                                                            debit: acc.debit + toNum(l.debit),
                                                            credit: acc.credit + toNum(l.credit)
                                                        }), { debit: 0, credit: 0 });

                                                        const totalDebit = totals.debit;
                                                        const totalCredit = totals.credit;
                                                        const outstanding = Math.max(0, totalDebit - totalCredit);

                                                        if (totalCredit === 0) {
                                                            return <span className={classes.statusPending}>Owing</span>;
                                                        }
                                                        if (totalDebit === 0 || outstanding === 0) {
                                                            return <span className={classes.statusPaid}>Paid</span>;
                                                        }
                                                        if (totalDebit !== (amountNum || totalDebit)) {
                                                            return <span className={(classes.statusWarning || classes.statusPending)}>Paid Part</span>;
                                                        }
                                                        return <span className={classes.statusPending}>Owing</span>;
                                                    }

                                                    // Last resort: balance
                                                    const bal = parseFloat(item.balance);
                                                    const paid = !isNaN(bal) && bal === 0;
                                                    return (
                                                        <span className={paid ? classes.statusPaid : classes.statusPending}>
                                                            {paid ? 'Paid' : 'Pending'}
                                                        </span>
                                                    );
                                                })()}
                                            </td> */}
                                            <td>{item.created_at?.split("T")[0] || "—"}</td>
                                            <td className={classes.actionsIcons}>
                                                <Pencil size={16} style={{ color: 'rgb(22, 163, 74)' }} />
                                                <Trash2 
                                                    size={16} 
                                                    style={{ color: 'rgb(255, 2, 2)', margin: '0 6px', cursor: 'pointer' }} 
                                                    onClick={() => handleReverseInvoice(item)}
                                                />
                                                <span
                                                    onClick={() =>
                                                        navigate('/reportinvoice', { state: { invoice: item, invoiceType: 'Sales Invoice' } })
                                                    }
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Printer size={16} style={{ color: 'rgb(37,99,235)' }} />
                                                </span>

                                            </td>

                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>

                        <div className={classes.paginationContainer}>
                            <div className={classes.paginationControls}>
                                <button>First</button>
                                <button className={classes.active}>1</button>
                                <button>2</button>
                                <button>Last</button>
                                <span className={classes.pageText}>
                                    Displaying 1 - {invoiceItems.length} of {invoiceItems.length}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <Footer />
        </div>
    );
};

export default Transactions;
